import { axiosInstance, ENDPOINT } from '../../../common/constants';
import { handleResponse } from '../../../common/helpers';

// One page of machine groups for the Group by Asset view: summaries, no rows.
export const getActivityGroups = params =>
  handleResponse(axiosInstance.get(ENDPOINT.GET_ACTIVITY, { params: { ...params, view: 'grouped' } }));

// The rows of one expanded group. `group_rows` asks the feed for exactly the
// sources that group's header was counted from, so the rows and the header agree.
export const getGroupActivities = params =>
  handleResponse(axiosInstance.get(ENDPOINT.GET_ACTIVITY, { params: { ...params, view: 'group_rows' } }));
